// @ts-nocheck
/* eslint-enable */
import assign from 'lodash/assign';
import omit from 'lodash/omit';
import queryUtils from 'app/shared/utils/queryUtils';

const controller = {
  makeLink(page, query, url) {
    const newQuery = controller.getQuery(page, query);

    return url + queryUtils.stringify(newQuery);
  },
  getQuery(page, query) {
    // Only use query parameter page=n if n != 1 (because ?page=1 would be default url)
    let newQuery;
    if (page !== 1) {
      newQuery = assign({}, query, {
        page,
      });
    } else {
      newQuery = omit(query, 'page');
    }

    return newQuery;
  },
  isEdgePage(page, maxPage) {
    // checks if the page link is for prev/next buttons
    if (page - 1 === maxPage || page + 1 === 1) {
      return true;
    } else {
      return false;
    }
  },
  isInvalidPage(page, maxPage) {
    return page > maxPage || page <= 0;
  },
};

export default controller;
